import React from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ProductListPage from './pages/ProductListPage';
import AdminLayout from './pages/admin/AdminLayout';
import ProductAdminPage from './pages/admin/ProductAdminPage';
import UserAdminPage from './pages/admin/UserAdminPage';
import OrderAdminPage from './pages/admin/OrderAdminPage';
import RoleAdminPage from './pages/admin/RoleAdminPage';
import UserLoginLogPage from './pages/admin/UserLoginLogPage';
import NotificationAdminPage from './pages/admin/NotificationAdminPage';
import CheckInLogPage from './pages/admin/CheckInLogPage';
import BasicDataAdminPage from './pages/admin/BasicDataAdminPage';
import ErrorPage from './pages/ErrorPage';
import WheelPage from './pages/admin/WheelPage';

// 定義路由表並啟用 v7 future flags
const router = createBrowserRouter(
  [
    { path: '/', element: <ProductListPage />, errorElement: <ErrorPage /> },
    { path: '/login', element: <LoginPage />, errorElement: <ErrorPage /> },
    { path: '/line-callback', element: <LoginPage />, errorElement: <ErrorPage /> },
    {
      path: '/admin', element: <AdminLayout />, errorElement: <ErrorPage />, children: [
        { index: true, element: <ProductAdminPage />, errorElement: <ErrorPage /> }, // 預設進入活動管理
        { path: 'checkin-logs', element: <CheckInLogPage />, errorElement: <ErrorPage /> },
        { path: 'products', element: <ProductAdminPage />, errorElement: <ErrorPage /> },
        { path: 'users', element: <UserAdminPage />, errorElement: <ErrorPage /> },
        { path: 'orders', element: <OrderAdminPage />, errorElement: <ErrorPage /> },
        { path: 'roles', element: <RoleAdminPage />, errorElement: <ErrorPage /> },
        { path: 'loginlog', element: <UserLoginLogPage />, errorElement: <ErrorPage /> },
        { path: 'notifications', element: <NotificationAdminPage />, errorElement: <ErrorPage /> },
        { path: 'basic-data', element: <BasicDataAdminPage />, errorElement: <ErrorPage /> },
        { path: 'wheel', element: <WheelPage />, errorElement: <ErrorPage /> }
      ]
    }
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

export default function App() {
  return <RouterProvider router={router} />;
}
